// src/pages/Home.jsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'; // react-helmet-async に統一
// コンポーネントのインポート
import HeroSection from '../components/HeroSection/HeroSection';
import TrustBadge from '../components/TrustBadge';
import FeaturesSection from '../components/FeatureSlider/FeaturesSection';
import FacilitySection from '../components/FacilitySection';
import ReviewSlider from '../components/ReviewSlider';
import BookingWidget from '../components/BookingWidget';
import HowToStay from '../components/HowToStay';
import FloorMap from '../components/FloorMap';
import Access from '../components/Access';
import FadeSection from '../components/FadeSection';

import './Home.css';

function Home() {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');
  const canonicalUrl = `https://kanazawa-stay-akebono.com${location.pathname}`;

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <html lang={isEnglish ? 'en' : 'ja'} />
        <title>{isEnglish ? 'Kanazawa Stay Akebono | Private Machiya Rental' : '【公式】金沢之旅宿 あけぼの｜一日一組限定の一棟貸し'}</title>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {/* 1. HERO ゾーン */}
      <HeroSection isEnglish={isEnglish} />

      {/* 2. TRUST（実績）ゾーン：少しネガティブマージンをかけてHeroに食い込ませる等の工夫も可能 */}
      <div className="home-zone-trust">
        <FadeSection delay={0.2}>
          <TrustBadge isEnglish={isEnglish} />
        </FadeSection>
      </div>

      {/* 3. ABOUT ゾーン（魅力と施設を同じ背景色でひとまとめにする） */}
      <div className="home-zone-about">
        <FadeSection id="about">
          <FeaturesSection isEnglish={isEnglish} />
        </FadeSection>
        <FadeSection id="facility">
          <FacilitySection isEnglish={isEnglish} />
        </FadeSection>
      </div>

      {/* 4. REVIEW ゾーン（背景色を少し変えてメリハリを出す） */}
      <div className="home-zone-review" style={{ backgroundColor: '#f5f4f0', padding: '40px 0' }}>
        <FadeSection>
          <ReviewSlider isEnglish={isEnglish} />
        </FadeSection>
      </div>

      {/* 5. BOOKING ゾーン（ブランドカラーの濃紺などで引き締め、予約への集中力を高める） */}
      <div className="home-zone-booking" style={{ backgroundColor: '#fdfbf7', paddingBottom: '60px' }}>
        <FadeSection id="booking">
          <BookingWidget isEnglish={isEnglish} />
        </FadeSection>
      </div>

      {/* 6. INFO ゾーン（実用情報） */}
      <div className="home-zone-info" style={{ borderTop: '1px solid #e0d8c3', paddingTop: '40px' }}>
        <FadeSection id="how-to-stay"><HowToStay isEnglish={isEnglish} /></FadeSection>
        <FadeSection id="floor-map"><FloorMap isEnglish={isEnglish} /></FadeSection>
        <FadeSection id="access"><Access isEnglish={isEnglish} /></FadeSection>
      </div>

      <div style={{ height: '50px' }}></div>
    </>
  );
}

export default Home;